@if (quizData) {
  <form action="" [formGroup]="quizForm" (ngSubmit)="endQuiz()">
    <swiper-container allow-touch-move="false" keyboard="false" #quizSwiper>
      @for (quiz of quizData; track $index; let quizIdx = $index) {
        @if (quiz.formType === 'quiz'){
          @if(quiz.questions.length > 0){
            @for(question of quiz.questions; track $index; let questionIdx = $index){
              <swiper-slide formArrayName="quizzes">
                @if(quizData.length !== 1) {
                    <h3><span>Étape {{ quizIdx + 1}} / {{ quizData.length }}</span> - {{ quiz.name }}</h3>
                    <h3><span>Question {{ questionIdx + 1 }} / {{ quiz.questions.length }}</span></h3>
                  }
                  @else {
                    <h3><span>{{ quiz.name }}</span> - Question {{ questionIdx + 1 }} / {{ quiz.questions.length }}</h3>
                  }
                <ion-list class="card" lines="full" [formArrayName]="quizIdx">
                  @if (question.type === "multichoice") {
                    @if (question.single === 1) {
                      <ion-item class="item-col" [formGroupName]="questionIdx">
                        <span>{{question.text}}</span>
                        <ion-radio-group labelPlacement="stacked" [formControlName]="question.id">
                          @for (answer of question.answers; track answer.id) {
                            <ion-radio labelPlacement="end" [value]="answer.id">{{answer.text}}</ion-radio>
                          }
                        </ion-radio-group>
                      </ion-item>
                    }
                    @else{
                      <ion-item class="item-col" [formGroupName]="questionIdx">
                        <span>{{ question.text }}</span>
                        @for(answer of question.answers; track $index){
                          <div class="checkbox-container" >        
                            <ion-checkbox labelPlacement="end" [value]="answer.id" [formControlName]="answer.id">{{ answer.text }}</ion-checkbox>
                          </div>
                        }
                      </ion-item>
                    }
                  }
                  @else if (question.type === "essay") {
                    <ion-item class="item-col" [formGroupName]="questionIdx">
                      <ion-textarea rows="1" labelPlacement="stacked" [label]="question.text" [formControlName]="question.id" [value]="question.text" [autoGrow]="true" placeholder="Entrez votre réponse ici"></ion-textarea>
                    </ion-item>
                  }
                </ion-list>
                @if (quizIdx + 1 === quizData.length && questionIdx + 1 === quiz.questions.length) {                
                  <ion-button id="button_suivant" shape="round" size="small" color="light" [disabled]="!quizzesFormArray.valid" type="submit" (click)="nextQuestion(quizIdx, questionIdx)">
                    Finir le quiz
                  </ion-button>
                }
                @else {                
                  @if ($last) {
                    <ion-button id="button_suivant" shape="round" size="small" color="light" [disabled]="!quizzesFormArray.get(quizIdx.toString())?.valid" (click)="nextQuestion(quizIdx, questionIdx)">
                      Finir l'étape {{quizIdx + 1}}
                    </ion-button>
                  } 
                  @else {
                    <ion-button id="button_suivant" shape="round" size="small" color="light" [disabled]="!quizzesFormArray.get(quizIdx.toString())?.get(questionIdx.toString())?.valid" (click)="nextQuestion(quizIdx, questionIdx)">
                      Suivant
                    </ion-button>
                  }
                }
              </swiper-slide>
            }
          }
        }
      }
    </swiper-container>
  </form>
}